// extracted by mini-css-extract-plugin
export var bodySections = "_3q-8";
export var gray = "_3q-7";
export var green = "_3q-4";
export var iconContainer = "_3q-9";
export var iconWidgetContainer = "_3q-1";
export var phoneIcon = "_3q-2";
export var red = "_3q-5";
export var statusDot = "_3q-3";
export var widgetContainer = "_3q-0";
export var yellow = "_3q-6";